// One place that mints a token used as a credential.
//
// Two links in this product hand access to someone with no account: the
// document delegation link (/d/<token>) and the supplier setup form
// (/supplier-form/<token>). In both cases the token IS the authentication —
// there is nothing else in front of the data — and the setup form's data is a
// supplier's bank account name, sort code and account number.
//
// So this must be the platform CSPRNG, every time. It previously was for
// delegation and was NOT for the setup form, which fell back to
// `${Date.now()}-${Math.random().toString(36)}` whenever crypto.randomUUID was
// unavailable — a guessable link to bank details. One helper, so the next
// token to be added cannot quietly get the weaker treatment.
//
// RETURNS NULL rather than a weak token when no CSPRNG is available. Callers
// must handle it: refusing to issue a link is recoverable, issuing a
// predictable one is not.
export function newSecureToken(bytes = 32) {
  const c = (typeof window !== 'undefined' && (window.crypto || window.msCrypto)) || null;
  if (!c || typeof c.getRandomValues !== 'function') return null;
  const buf = new Uint8Array(bytes);
  c.getRandomValues(buf);
  return Array.from(buf, b => b.toString(16).padStart(2, '0')).join('');
}
